module.exports = __webpack_public_path__ + "img/3.a2b5d7d2.jpg";